import { useEffect, useState } from 'react';
import { getMobileAppKeyboardShown } from './mobileAppHandlers';

export const useIsMobileAppKeyboardVisible = () => {
  const [isMobileAppKeyboardVisible, setIsMobileAppKeyboardVisible] = useState<boolean>(false);
  const mobileAppKeyboardVisibilityRefreshEventName = "flamingo-keyboard-refresh";
  useEffect(() => {
    const refreshMobileAppParams = () => {
      const mobileAppKeyboardShownToSet = getMobileAppKeyboardShown();
      setIsMobileAppKeyboardVisible(mobileAppKeyboardShownToSet);
    };
    refreshMobileAppParams();
    document.addEventListener(mobileAppKeyboardVisibilityRefreshEventName, refreshMobileAppParams);
    return () => {
      document.removeEventListener(mobileAppKeyboardVisibilityRefreshEventName, refreshMobileAppParams);
    };
  }, []);
  return isMobileAppKeyboardVisible;
}